import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.concat.js";
import { BaseTransformer } from './BaseTransformer';
export var ContactNameTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ContactNameTransformer, _BaseTransformer);
  var _super = _createSuper(ContactNameTransformer);
  function ContactNameTransformer() {
    _classCallCheck(this, ContactNameTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ContactNameTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        value: data.record_id,
        label: "".concat(data.firstname, " ").concat(data.lastname),
        firstname: data.firstname,
        lastname: data.lastname,
        record_id: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return ContactNameTransformer;
}(BaseTransformer);